import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
    getReportTitles,
    getAlerts,
    getUsers,
    setAlertStatus,
    setAlertFilter,
} from "./actions";
import { StyledContent, StyledViewContainer } from "../../../styles";
import styled from "styled-components";
import {
    Typography,
    List,
    ListItem,
    ListItemText,
    IconButton,
    ListItemSecondaryAction,
    Button,
    Radio,
    Snackbar,
    SnackbarContent,
    FormControl,
    TextField
} from "@material-ui/core";
import {
    NotificationImportant as AlertIcon,
    RemoveRedEye as ViewIcon,
} from "@material-ui/icons";
import { Link } from "react-router-dom";

import {
    Modal,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Spinner,
} from "reactstrap";

const FilterTypeDiv = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-top: 10px;
    margin-bottom: 20px;
`;
class ReportsAlertWidget extends Component {
    constructor(props) {
        super(props);
        props.getAlerts();
        props.getReportTitles();
        props.getUsers();

        this.state = {
            editModal: false,
            modalAlert: false,
            updateAlertFail: false,
            updateAlertSuccess: false,
            actionTaken:'',
            supplierReference:''
        };
    }

    render() {
        const { alerts, users, reportTitles, clientDetails } = this.props;
        var title = clientDetails.title;
        return (
            <StyledContent>
                <Fragment>
                    <FilterTypeDiv style={{ marginBottom: "0px" }}>
                        <FilterTypeRadio
                            onChange={(event) => {
                                this.props.setAlertFilter(event.target.value);
                            }}
                            text="Active"
                            checked={this.props.statusType}
                            type="active"
                        />
                        <FilterTypeRadio
                            onChange={(event) => {
                                this.props.setAlertFilter(event.target.value);
                            }}
                            text="Resolved"
                            checked={this.props.statusType}
                            type="resolved"
                        />
                    </FilterTypeDiv>
                    <StyledViewContainer>
                        {!alerts && (
                            <Typography variant="h1">
                                No Alerts At This Time
                            </Typography>
                        )}
                        <Modal
                            isOpen={this.props.requesting}
                            style={{ maxWidth: "00px" }}
                        >
                            <ModalBody>
                                <div
                                    style={{
                                        textAlign: "center",
                                        paddingTop: "3em",
                                    }}
                                >
                                    <div
                                        style={{
                                            background: "white",
                                            width: "fit-content",
                                            display: "inline-block",
                                            padding: "2em",
                                        }}
                                    >
                                        <Spinner
                                            style={{
                                                height: 100,
                                                width: 100,
                                                background: "white",
                                            }}
                                            color="primary"
                                        />
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                marginTop: 15,
                                                color: "rgba(0, 0, 0, 0.87)",
                                                fontWeight: "bolder",
                                                fontSize: 20,
                                            }}
                                            variant="body2"
                                        >
                                            Processing...
                                        </Typography>
                                    </div>
                                </div>
                            </ModalBody>
                        </Modal>
                        <List dense={false}>
                            {alerts &&
                                users &&
                                Object.keys(alerts).map((e, i) => {
                                    let reportType =
                                        reportTitles[alerts[e].report_type];
                                    let user = users.filter((f) => {
                                        return (
                                            f.uid === alerts[e].created_by_uid
                                        );
                                    });
                                    let resolvedBy = users.filter((f) => {
                                        return f.uid === alerts[e].resolved_by;
                                    });
                                    if (
                                        alerts[e].status ===
                                        this.props.statusType
                                    ) {
                                        return (
                                            <ListItem key={i}>
                                                <IconButton
                                                    onClick={() => {
                                                        if (
                                                            this.props
                                                                .permissions
                                                                .update
                                                        )
                                                            this.setState({
                                                                editModal: true,
                                                                modalAlert:
                                                                    alerts[e],
                                                            });
                                                    }}
                                                    style={{
                                                        color:
                                                            alerts[e].status ===
                                                            "active"
                                                                ? "red"
                                                                : "green",
                                                        border: `1px solid ${
                                                            alerts[e].status ===
                                                            "active"
                                                                ? "red"
                                                                : "green"
                                                        }`,
                                                    }}
                                                >
                                                    <AlertIcon />
                                                </IconButton>
                                                <ListItemText
                                                    primary={`${reportType} Alert: ${
                                                        alerts[e].status ===
                                                        "active"
                                                            ? "Active"
                                                            : `Resolved by ${resolvedBy[0].name} , Action taken : ${ alerts[e].actionTaken ? alerts[e].actionTaken : `N/A`}, Supplier Reference ${alerts[e].supplierReference ? alerts[e].supplierReference : `N/A` }`
                                                    }`}
                                                    secondary={`Created ${alerts[e].timestamp} by ${
                                                        user[0] ? user[0].name : "N/A"
                                                    }`
                                                }
                                                />
                                                      

                                                <ListItemSecondaryAction>
                                                    {alerts[e].subject_name ===
                                                    "reports" ? (
                                                        <Link
                                                            to={`report-view-standalone/${
                                                                alerts[e]
                                                                    .subject_name
                                                            }/${
                                                                alerts[e]
                                                                    .subject_child
                                                            }/${alerts[
                                                                e
                                                            ].report_type.replace(
                                                                /_/g,
                                                                "-"
                                                            )}/${alerts[
                                                                e
                                                            ].timestamp
                                                                .replace(
                                                                    /:/g,
                                                                    "."
                                                                )
                                                                .replace(
                                                                    / /g,
                                                                    "_"
                                                                )}`}
                                                        >
                                                            <IconButton
                                                                style={{
                                                                    color:
                                                                        "indigo",
                                                                    border:
                                                                        "1px solid indigo",
                                                                }}
                                                                aria-label="View"
                                                            >
                                                                <ViewIcon />
                                                            </IconButton>
                                                        </Link>
                                                    ) : (
                                                        <Link
                                                            to={`report-view/${
                                                                alerts[e]
                                                                    .subject_name
                                                            }/${
                                                                alerts[e]
                                                                    .subject_child
                                                            }/${alerts[
                                                                e
                                                            ].report_type.replace(
                                                                /_/g,
                                                                "-"
                                                            )}/${alerts[
                                                                e
                                                            ].timestamp
                                                                .replace(
                                                                    /:/g,
                                                                    "."
                                                                )
                                                                .replace(
                                                                    / /g,
                                                                    "_"
                                                                )}`}
                                                        >
                                                            <IconButton
                                                                style={{
                                                                    color:
                                                                        "indigo",
                                                                    border:
                                                                        "1px solid indigo",
                                                                }}
                                                                aria-label="View"
                                                            >
                                                                <ViewIcon />
                                                            </IconButton>
                                                        </Link>
                                                    )}
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                        </List>
                    </StyledViewContainer>
                    <Snackbar
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                        }}
                        autoHideDuration={6000}
                        open={
                            this.state.updateAlertFail ||
                            this.state.updateAlertSuccess
                        }
                        onClose={() => {
                            this.setState({
                                updateAlertFail: false,
                                updateAlertSuccess: false,
                            });
                        }}
                    >
                        <SnackbarContent
                            style={{
                                backgroundColor: this.state.updateAlertSuccess
                                    ? "green"
                                    : this.state.updateAlertFail
                                    ? "red"
                                    : "white",
                                color: "white",
                            }}
                            message={
                                this.state.updateAlertSuccess
                                    ? "Alert was updated successfully !"
                                    : this.state.updateAlertFail
                                    ? "Unable to update alert, Please Contact Admin"
                                    : ""
                            }
                        />
                    </Snackbar>
                    <Modal isOpen={this.state.editModal}>
                        <ModalHeader>Set Alert Status </ModalHeader>
                        <ModalBody>
                            {this.state.modalAlert && (
                                <>
                                <Typography variant="body2">
                                    Set alert for{" "}
                                    <b>
                                        {this.state.modalAlert.report_type.replace(
                                            /_/g,
                                            " "
                                        )}
                                    </b>{" "}
                                    created{" "}
                                    <b>{this.state.modalAlert.timestamp}</b> to{" "}
                                    <b>
                                        {this.state.modalAlert.status ===
                                        "active"
                                            ? "resolved"
                                            : "active"}
                                    </b>{" "}
                                    ?
                                </Typography>
                                {title === 'JCEnviro ' ? <>
                                <FormControl>
                                
                                <TextField
                                    key={"actionTaken"}
                                    value={this.state.actionTaken}
                                    label={"Action Taken"}
                                    onChange={val => {
                                    this.setState({ actionTaken : val.target.value });
                                    }}
                                />
                                </FormControl>< br/>
                                <FormControl>

                                <TextField
                                    key={"supplierRefrence"}
                                    value={this.state.supplierReference}
                                    label={"Supplier Reference"}
                                    onChange={val => {
                                    this.setState({ supplierReference :   val.target.value});
                                    }}
                                />
                                </FormControl>
                                </> : '' }
                               
                                </>
                            )}
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                variant="contained"
                                onClick={() =>
                                    this.setState({
                                        editModal: false,
                                    })
                                }
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    this.props.setAlertStatus(
                                        this.state.modalAlert.timestamp,
                                        this.state.actionTaken,
                                        this.state.supplierReference,
                                        this.state.modalAlert.status ===
                                            "active"
                                            ? "resolved"
                                            : "active",
                                        (success) => {
                                            if (success)
                                                this.setState({
                                                    updateAlertSuccess: true,
                                                });
                                            else
                                                this.setState({
                                                    updateAlertFail: true,
                                                });
                                        }
                                    );
                                    this.setState({ editModal: false });
                                }}
                            >
                                Update
                            </Button>
                        </ModalFooter>
                    </Modal>
                </Fragment>
            </StyledContent>
        );
    }
}
const FilterTypeRadio = (props) => {
    return (
        <div style={{ display: "flex" }}>
            <Typography
                variant="body2"
                style={{ color: props.color, marginTop: 10 }}
            >
                <b>{props.text}</b>
            </Typography>
            <Radio
                color="primary"
                checked={props.checked === props.type}
                value={props.type}
                onClick={(event) => props.onChange(event)}
            />
        </div>
    );
};
export default connect(
    (store, props) => {
        const { selectors } = props;
        const {
            selectReportTitles,
            selectAlerts,
            selectUserInfo,
            selectFilter,
            getRequesting,
            selectClientDetails
        } = selectors;
        return {
            reportTitles: selectReportTitles(store),
            alerts: selectAlerts(store),
            users: selectUserInfo(store),
            statusType: selectFilter(store),
            requesting: getRequesting(store),
            clientDetails: selectClientDetails(store)
        };
    },
    { getAlerts, getReportTitles, getUsers, setAlertStatus, setAlertFilter }
)(ReportsAlertWidget);
